module.exports = __webpack_public_path__ + "static/media/festival_05.ad145070.jpg";